import { ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { ButtonSeverity, ButtonSize, ButtonVariant, FcpButtonComponent } from '../fcp-button/fcp-button.component';
import { FcpMessageSeverity } from '../../services/fcp-message.service';

@Component({
    selector: 'fcp-message',
    imports: [MessageModule, FcpButtonComponent],
    styleUrl: './fcp-message.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        <p-message [severity]="severity()" [icon]="severityIcon()" [closable]="closable()" (onClose)="handleClose()">
            <div class="fcp-message-body">
                <div class="fcp-message-text">
                    <div class="fcp-message-label">{{ text() }}</div>
                    @if (content()) {
                        <div class="fcp-message-content">{{ content() }}</div>
                    }
                </div>
                @if (actionLabel()) {
                    <fcp-button
                        [label]="actionLabel()!"
                        [buttonVariant]="messageActionButtonVariant"
                        [buttonSeverity]="actionButtonSeverity"
                        [buttonSize]="actionButtonSize"
                        (onClick)="handleAction()"
                    />
                }
            </div>
        </p-message>
    `
})
export class FcpMessageComponent {
    readonly messageActionButtonVariant = ButtonVariant.Link;
    readonly actionButtonSeverity = ButtonSeverity.Secondary;
    readonly actionButtonSize = ButtonSize.Normal;

    e2e = input<string | null>(null);
    severity = input<FcpMessageSeverity>(FcpMessageSeverity.Info);
    text = input<string>('');
    closable = input<boolean>(false);
    actionLabel = input<string | null>(null);
    content = input<string | null>(null);

    onClose = output<void>();
    onAction = output<void>();

    private readonly severityIconMap: Record<FcpMessageSeverity, string> = {
        [FcpMessageSeverity.Success]: 'fc-font-icon fc-font-icon-circle-check-fill',
        [FcpMessageSeverity.Warning]: 'fc-font-icon fc-font-icon-circle-warning-fill',
        [FcpMessageSeverity.Error]: 'fc-font-icon fc-font-icon-circle-exclamation-fill',
        [FcpMessageSeverity.Info]: 'fc-font-icon fc-font-icon-circle-info-fill',
        [FcpMessageSeverity.Secondary]: 'fc-font-icon fc-font-icon-circle-info-fill'
    };

    severityIcon = computed(() => this.severityIconMap[this.severity()]);

    handleClose(): void {
        this.onClose.emit();
    }

    handleAction(): void {
        this.onAction.emit();
    }
}
